/**
 * Constantes pour les rôles utilisateur côté frontend
 */

export const USER_ROLES = {
  OWNER: 'owner',
  RENTER: 'renter', 
  BOTH: 'both',
  ALL: 'all'
};

/**
 * Labels pour affichage des rôles
 */
export const USER_ROLE_LABELS = {
  [USER_ROLES.OWNER]: 'Propriétaire',
  [USER_ROLES.RENTER]: 'Locataire',
  [USER_ROLES.BOTH]: 'Les deux',
  [USER_ROLES.ALL]: 'Tous'
};
